import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'pv-snack-action',
    template: `
    <span class="snackbar-message mat-body">{{ data.message }}</span>
    <button class="snack-button" type="button" mat-button color="accent" (click)="action()">{{ data.actionLabel }}</button>
    `,
    styleUrls: ['snackbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
})
export class SnackActionComponent {

    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: SnackActionData,
        private _ref: MatSnackBarRef<SnackActionComponent>,
    ) { }

    action() {
        this._ref.dismissWithAction();
    }
}

export interface SnackActionData {
    message: string;
    actionLabel: string;
}
